<template>
    <div>
      <div class="NCSInfo dark:bg-hero-purple dark:border-hero-purple mb-5">
        <div class="flex items-center">
          <div class="w-[42px] h-[42px] bg-white rounded-full flex items-center justify-center mr-4 p-2">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="text-blue-600"
            >
              <path d="M4.5 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM14.25 8.625a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0ZM1.5 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM17.25 19.128l-.001.144a2.25 2.25 0 0 1-.233.96 10.088 10.088 0 0 0 5.06-1.01.75.75 0 0 0 .42-.643 4.875 4.875 0 0 0-6.957-4.611 8.586 8.586 0 0 1 1.71 5.157v.003Z" fill="#4b5d77"/>
            </svg>
          </div>
          <div>
        <h3 class="font-medium mt-2 dark:text-white">
          Negative Coping Strategies
        </h3>
        <p class="mb-4 dark:text-white">
          If you rely on negative coping strategies, help is available. Connecting with support services, such as counseling or a support group, can provide healthier ways to manage stress and emotions. Seeking help is a sign of strength and can lead to positive, lasting change.
          <br/>
          <a target="_blank" class="text-link-blue font-bold dark:text-link-light-blue pb-1" href="https://wellness.carleton.ca/counselling/">Learn more about help that is available.</a>
        </p>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: "NCS",

    data() {
      return {};
    },
  };
  </script>
